import { CharacterType } from "../features/character/types";
export default function checkIsGroupCharacter({ character }) {
    return character?.type === CharacterType.META;
}
